import { MotionValue } from "motion";
import { useMotionValue, useSpring, useTransform } from "motion/react";
import { useRaf } from "./use-raf";

const baseWidth = 56;
const distanceLimit = baseWidth * 7;
const beyondTheDistanceLimit = distanceLimit + 1;
const distanceInput = [
  -distanceLimit,
  -distanceLimit / 1.25,
  -distanceLimit / 2,
  0,
  distanceLimit / 2,
  distanceLimit / 1.25,
  distanceLimit,
];
const widthOutput = [
  baseWidth,
  baseWidth * 1.1,
  baseWidth * 1.214,
  baseWidth * 1.6,
  baseWidth * 1.214,
  baseWidth * 1.1,
  baseWidth,
];

export const useDockHoverAnimation = (mouseX: MotionValue, ref: any) => {
  const distance = useMotionValue(beyondTheDistanceLimit);
  const widthPX = useSpring(useTransform(distance, distanceInput, widthOutput), {
    stiffness: 1300,
    damping: 82,
  });

  const width = useTransform(widthPX, (w) => `${w / 16}rem`);

  useRaf(() => {
    if (!ref.current) {
      return;
    }
    const el = ref.current;
    const mouseXVal = mouseX.get();
    if (el && mouseXVal !== null) {
      const rect = el.getBoundingClientRect();
      const imgCenterX = rect.left + rect.width / 2;
      // difference between the x coordinate value of the mouse pointer
      // and the img center x coordinate value
      const distanceDelta = mouseXVal - imgCenterX;
      distance.set(distanceDelta);
      return;
    }

    distance.set(beyondTheDistanceLimit);
  }, true);

  return { width };
};
